// Generated by npm run icons:generate. Do not edit.
// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
import { MaterialSymbol, type MaterialIconProps } from "./material-symbol";

const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m578-151-218-65-169 56q-9 3-17 1.5t-15-6.5q-7-5-11-12.5t-4-16.5v-515q0-16 9.5-28.5T177-755l161-54q5-2 11-2.5t11-.5q5 0 11 .5t11 2.5l218 65 169-56q9-3 17-1.5t15 6.5q7 5 11 12.5t4 16.5v515q0 16-9 29t-24 17l-161 54q-5 2-11 2.5t-11 .5q-5 0-11-.5t-11-2.5Zm-14-79v-450l-168-50v450l168 50Zm72-2 108-36v-448l-108 36v448Zm-420-12 108-36v-448l-108 36v448Zm420-436v448-448Zm-312-48v448-448Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m574-129-214-75-186 72q-10 4-19.5 2.5T137-136q-8-5-12.5-13.5T120-169v-561q0-13 7.5-23t20.5-15l186-63q6-2 12.5-3t13.5-1q7 0 13.5 1t12.5 3l214 75 186-72q10-4 19.5-2.5T823-824q8 5 12.5 13.5T840-791v561q0 13-7.5 23T812-192l-186 63q-6 2-12.5 3t-13.5 1q-7 0-13.5-1t-12.5-3Zm-14-89v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m578-151-218-65-169 56q-9 3-17 1.5t-15-6.5q-7-5-11-12.5t-4-16.5v-515q0-16 9.5-28.5T177-755l161-54q5-2 11-2.5t11-.5q5 0 11 .5t11 2.5l218 65 169-56q9-3 17-1.5t15 6.5q7 5 11 12.5t4 16.5v515q0 16-9 28.5T783-205l-161 54q-5 2-11 2.5t-11 .5q-5 0-11-.5t-11-2.5Zm-14-79v-450l-168-50v450l168 50Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m574-129-214-75-186 72q-10 4-19.5 2.5T137-136q-8-5-12.5-13.5T120-169v-561q0-13 7.5-23t20.5-15l186-63q6-2 12.5-3t13.5-1q7 0 13.5 1t12.5 3l214 75 186-72q10-4 19.5-2.5T823-824q8 5 12.5 13.5T840-791v561q0 13-7.5 23T812-192l-186 63q-6 2-12.5 3t-13.5 1q-7 0-13.5-1t-12.5-3Zm-14-89v-468l-160-56v468l160 56Z"
    ]
  }
} as const;

export function MapIcon(props: MaterialIconProps) {
  return <MaterialSymbol {...props} symbol="map" artwork={artwork} />;
}
